import { LayerProps } from "react-map-gl";
import { routeRVIconScale } from "../../app/constants";
import { PRETTY_BLUE } from "../trips/form/BorderWithLabel";
import { ROUTE_DISPLAY_TYPES, RouteDisplayType } from "./geoUtils";

/**
 * Style for map icons
 */
export const iconStyle = {
    color: "white",
    scale: `${routeRVIconScale * 0.7}%`,
    position: "absolute",
} as React.CSSProperties;

export const faIconStyle = {
    color: "white",
    paddingTop: "4px",
    paddingLeft: "3px",
    scale: `${routeRVIconScale * 0.7}%`,
    position: "absolute",
} as React.CSSProperties;

/**
 * Style for fontawesome icon icons
 */
export const iconStyleFa = {
    position: "absolute",
    color: "white",
    paddingTop: "3px",
    paddingLeft: "1px"
} as React.CSSProperties;

type RouteLayerStyle = {
    color: string,
    dash?: Array<number>,
};

export const ROUTE_LAYER_STYLES: Record<RouteDisplayType, RouteLayerStyle> = {
    [ROUTE_DISPLAY_TYPES.ROUTE]: { color: PRETTY_BLUE },
    [ROUTE_DISPLAY_TYPES.POST]: { color: PRETTY_BLUE, dash: [ 0.5, 0.5 ] },
    [ROUTE_DISPLAY_TYPES.OUTSIDE]: { color: PRETTY_BLUE, dash: [ 0.5, 0.5 ] },
    [ROUTE_DISPLAY_TYPES.GOLDILOCKS]: { color: "#B2EBF2" },
    [ROUTE_DISPLAY_TYPES.NO_IMPACT]: { color: "#FFFFFF" },
    [ROUTE_DISPLAY_TYPES.LEVEL_ONE]: { color: "#FFF59D" },
    [ROUTE_DISPLAY_TYPES.LEVEL_TWO]: { color: "#FFC107" },
    [ROUTE_DISPLAY_TYPES.LEVEL_THREE]: { color: "#F57C00" },
    [ROUTE_DISPLAY_TYPES.LEVEL_FOUR]: { color: "#E91E63" },
    [ROUTE_DISPLAY_TYPES.LEVEL_FIVE]: { color: "#880E4F" },
};

export const createRouteLayer = (
    routeType: RouteDisplayType,
    routeNumber: number,
    isSelected: boolean,
    index: number,
    lineOpacity: number,
): LayerProps =>
{
    const style = ROUTE_LAYER_STYLES[routeType];

    return {
        id: `route-layer-${routeType}-${routeNumber}-${index}`,
        type: "line",
        paint: {
            "line-color": isSelected ? style.color ?? PRETTY_BLUE : "#84afd9",
            "line-width": isSelected ? 6 : 3,
            "line-opacity": lineOpacity,
            ...( style.dash !== undefined ? { "line-dasharray": isSelected ? style.dash : [] } : {} )
        },
    };
};


/**
 * Styled routes plotted on the map during the wilma forecast
 */
export const createDeselectedRouteLayer = ( routeNumber: number ): LayerProps => ( {
    id: `route-layer-deselected-${routeNumber}`,
    type: "line",
    paint: {
        "line-color": "#8c8c8c",
        "line-width": 2,
    },
} );

/**
 * Styled route background plotted on the map
 */
export const createBackgroundRouteLayer = ( lineOpacity: number, isOuter: boolean ): LayerProps => ( {
    id: `route-layer-background-${isOuter ? "outer" : "inner"}`,
    type: "line",
    paint: {
        "line-color": isOuter ? "#676767" : "white",
        "line-width": isOuter ? 9 : 6,
        "line-opacity": lineOpacity,
    },
} );
